<template>

    <section id="not-found" class="v-center text-center  mt-5">
        <div>
            <div>
                <h1 class="display-4">404 - Page Not Found</h1>
                <p class="lead">Sorry, the page you are looking for does not exist.</p>
                <router-link class="btn btn-primary" :to="mainSite">Go to Main Site</router-link>
            </div>
        </div>
    </section>

</template>

<script>
export default {
    name: 'NotFound',
    props: {
        mainSite: {
            type: String,
            default: () => ({name: 'Home'})
        }
    },
    mounted() {
        document.title = '404 - Page Not Found';
        if (window.mainUI && typeof window.mainUI === 'function')
            window.mainUI();
    },
}
</script>

<style lang="scss">
#not-found {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    .lead {
        margin-bottom: 2.5rem;
    }
}
</style>